
import { Action } from 'redux';

import { ProductStockActionTypes, ProductStockLevel, ProductStockState, } from './types';
import { ProductStockActions } from './actions'
import { createReducer } from '../../reducer';


const unloadedState: ProductStockState =
{
    isLoading: false,
    venueId: '',
    stockDate: new Date(),
    stockLevels: [],
    loadError: null,
    isLoadingOverview: false,
    overviewStockDate: new Date(),
    overviewStockLevels: [],
    overviewLoadError: null
};

export const reducer = (state: ProductStockState, incomingAction: Action) => createReducer(state, incomingAction, unloadedState, reducerHandler);

export const reducerHandler = (state: ProductStockState, incomingAction: Action): ProductStockState => {

    const action = incomingAction as ProductStockActions;
    switch (action.type) {
        case ProductStockActionTypes.RequestVenueStockLevels:
            return {
                ...state,
                isLoading: true,
                stockLevels: state.stockLevels,
                loadError: null
            };
        case ProductStockActionTypes.ReceivedVenueStockLevels:
            return {
                ...state,
                isLoading: false,
                venueId: action.venueId,
                stockDate: action.stockDate,
                stockLevels: action.stockLevels,
                loadError: action.error
            };
        case ProductStockActionTypes.RequestVenueStockOverview:
            return {
                ...state,
                isLoadingOverview: true,
                overviewStockDate: action.stockDate,
                overviewStockLevels: state.stockLevels,
                overviewLoadError: null
            };
        case ProductStockActionTypes.ReceivedVenueStockOverview:
            return {
                ...state,
                isLoadingOverview: false,
                overviewStockDate: action.stockDate,
                overviewStockLevels: action.stockLevels,
                overviewLoadError: action.error
            };
        case ProductStockActionTypes.ProductStockChanged:
            return state;

        case ProductStockActionTypes.ReceivedIndividualProductStock:
            const stockMap = new Map<string, ProductStockLevel>();
            for (const item of state.stockLevels) {
                stockMap.set(`${item.productId}_${item.productVariantId}`, item);
            }

            for (const item of action.stockLevels) {
                stockMap.set(`${item.productId}_${item.productVariantId}`, item);
            }

            return {
                ...state,
                isLoading: false,
                stockLevels: Array.from(stockMap.values()),
                loadError: null
            };
        case ProductStockActionTypes.ReceivedIndividualProductStockOverview:
            const overviewStockMap = new Map<string, ProductStockLevel>();
            for (const item of state.overviewStockLevels) {
                overviewStockMap.set(`${item.productId}_${item.productVariantId}`, item);
            }

            for (const item of action.stockLevels) {
                overviewStockMap.set(`${item.productId}_${item.productVariantId}`, item);
            }

            return {
                ...state,
                isLoadingOverview: false,
                overviewStockLevels: Array.from(overviewStockMap.values()),
                overviewLoadError: null
            };
        case ProductStockActionTypes.VenueChanged:
            const newState = state.venueId === action.venueId
                ? state
                : {
                    ...state,
                    venueId: action.venueId,
                    stockLevels: [],
                    loadError: null
                }
                return newState;
        default:
            // The following line guarantees that every action in the KnownAction union has been covered by a case above
            // eslint-disable-next-line
            const exhaustiveCheck: never = action;
    }

    return state || unloadedState;
};

